export default __webpack_public_path__ + "media/images/images_v2/fleche-haut-2a4dab69e83d562014587fa0652bc50c.png";